module.exports = __webpack_public_path__ + "img/visa.519e5f6f.png";